import { createReducer, on } from '@ngrx/store';
import { Customer } from '@api/models/customer';
import { UserLoad, UserLoadCustomersFailure, UserLoadCustomersSuccess, UserLoadProfileSuccess, UserReset } from './user.actions';
import { UserRoleEnum } from '@app/admin/user/model/user.model';
import { CurrentUser } from '@app/core/auth/current-user';

export interface UserState {
  profile?: CurrentUser | null;
  customers?: Customer[] | null;
  loading: boolean;
  error: string | null;
  isAdmin: boolean;
}

export const initialState: UserState = {
  profile: null,
  customers: null,
  isAdmin: false,
  loading: false,
  error: null,
};

export const userReducer = createReducer(
  initialState,

  on(UserLoad, state => ({ ...state, loading: true })),
  on(UserLoadCustomersSuccess, (state, { customers }) => ({
    ...state,
    customers,
    loading: false,
    error: null,
  })),
  on(UserLoadCustomersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(UserLoadProfileSuccess, (state, { response }) => {
    return {
      ...state,
      profile: response,
      isAdmin: response.roleId === UserRoleEnum.Admin && !response?.currentCustomerId,
      loading: false,
      error: null,
    };
  }),
  on(UserReset, (state, { }) => ({
    ...state,
    profile: null,
    customers: null,
    isAdmin: false,
    loading: false,
    error: null,
  }))
);
